module.exports = __webpack_public_path__ + "img/goodsA3.f84d8d52.png";